var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const DEFAULTS = {
    typingDelayMs: 100,
    phrasePauseMs: 1000,
    eraseBeforeNext: true,
    eraseDelayMs: 60,
    loop: true,
    shuffle: false,
};
export class TypingPlaceholder {
    constructor(options = {}) {
        this.isRunning = false;
        this.timerId = null;
        this.index = 0;
        const { selector, element, phrases } = options, rest = __rest(options, ["selector", "element", "phrases"]);
        const el = element !== null && element !== void 0 ? element : (selector
            ? document.querySelector(selector)
            : null);
        if (!el)
            throw new Error("[TypingPlaceholder] Target element not found.");
        if (!("placeholder" in el))
            throw new Error("[TypingPlaceholder] Target must support placeholder.");
        this.el = el;
        this.opts = Object.assign(Object.assign({}, DEFAULTS), rest);
        this.phrases = this.pickPhrases(phrases);
        if (this.opts.shuffle) {
            this.phrases = this.phrases.sort(() => Math.random() - 0.5);
        }
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isRunning)
                return;
            this.isRunning = true;
            while (this.isRunning) {
                const phrase = this.phrases[this.index];
                if (!phrase)
                    break;
                // 1) печатаем
                yield this.typePhrase(phrase);
                if (!this.isRunning)
                    break;
                // 2) ждём паузу после фразы
                yield this.sleep(this.opts.phrasePauseMs);
                if (!this.isRunning)
                    break;
                // 3) решаем, стирать ли фразу
                const lastCycleStep = (this.index + 1) % this.phrases.length === 0;
                const isLastAndNoLoop = lastCycleStep && !this.opts.loop;
                if (this.opts.eraseBeforeNext && !isLastAndNoLoop) {
                    yield this.eraseCurrent();
                    if (!this.isRunning)
                        break;
                }
                else if (!this.opts.eraseBeforeNext && !isLastAndNoLoop) {
                    // если не стираем — просто очищаем перед следующей
                    this.setPlaceholder("");
                }
                // 4) переходим к следующей
                this.index = (this.index + 1) % this.phrases.length;
                // 5) если цикл не зациклен — завершаем
                if (isLastAndNoLoop) {
                    this.stop();
                }
            }
        });
    }
    stop() {
        this.isRunning = false;
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
    }
    setPhrases(next, resetIndex = true) {
        this.phrases = [...next];
        if (resetIndex)
            this.index = 0;
    }
    typePhrase(phrase) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            let current = (_a = this.el.getAttribute("placeholder")) !== null && _a !== void 0 ? _a : "";
            if (current.length) {
                this.setPlaceholder("");
                current = "";
            }
            for (let i = 0; i < phrase.length && this.isRunning; i++) {
                current += phrase[i];
                this.setPlaceholder(current);
                yield this.sleep(this.opts.typingDelayMs);
            }
        });
    }
    eraseCurrent() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            let current = (_a = this.el.getAttribute("placeholder")) !== null && _a !== void 0 ? _a : "";
            while (current.length && this.isRunning) {
                current = current.slice(0, -1);
                this.setPlaceholder(current);
                yield this.sleep(this.opts.eraseDelayMs);
            }
        });
    }
    sleep(ms) {
        return new Promise((resolve) => {
            const start = performance.now();
            const tick = (now) => {
                if (!this.isRunning) {
                    resolve();
                    return;
                }
                if (now - start >= ms) {
                    resolve();
                }
                else {
                    requestAnimationFrame(tick);
                }
            };
            requestAnimationFrame(tick);
        });
    }
    setPlaceholder(value) {
        this.el.setAttribute("placeholder", value);
    }
    pickPhrases(fromOptions) {
        if (fromOptions === null || fromOptions === void 0 ? void 0 : fromOptions.length)
            return [...fromOptions];
        const raw = this.el.getAttribute("data-phrases");
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed) &&
                    parsed.every((p) => typeof p === "string")) {
                    return parsed;
                }
            }
            catch (_a) {
                // некорректный JSON → используем дефолт ниже
            }
        }
        return [];
    }
}
